export enum GetEmailValidationActionTypes {
  EMAIL_INPUT = 'EMAIL_INPUT',
  EMAIL_SUBMIT = 'EMAIL_SUBMIT',
  RESET_STATE = 'EMAIL_RESET_STATE',
}

interface EmailResetState {
  type: GetEmailValidationActionTypes.RESET_STATE;
}

interface EmailInputAction {
  type: GetEmailValidationActionTypes.EMAIL_INPUT;
  emailValue: string;
}

interface EmailSubmitAction {
  type: GetEmailValidationActionTypes.EMAIL_SUBMIT;
  emailValue: string;
}

export function setEmailAction(emailValue: string): EmailInputAction {
  return {
    type: GetEmailValidationActionTypes.EMAIL_INPUT,
    emailValue,
  };
}

export function emailSubmitAction(emailValue: string): EmailSubmitAction {
  return {
    type: GetEmailValidationActionTypes.EMAIL_SUBMIT,
    emailValue,
  };
}

export function setResetState(): EmailResetState {
  return {
    type: GetEmailValidationActionTypes.RESET_STATE,
  };
}

export type EmailValidateActions = EmailInputAction | EmailSubmitAction | EmailResetState;
